module.exports = __webpack_public_path__ + "img/product_28.a4a8a65.webp";